import { MaskedLine, Reveal } from "./motion";

const AdobeTile = ({ letters, label, testId }) => (
    <div data-testid={testId} className="group flex items-center gap-4">
        <span className="flex h-14 w-14 items-center justify-center rounded-lg border border-[#D4AF37]/40 bg-gradient-to-br from-[#111113] to-[#050505] shadow-[0_0_20px_rgba(212,175,55,0.1)] transition-all duration-500 group-hover:border-[#D4AF37] group-hover:shadow-[0_0_30px_rgba(212,175,55,0.25)]">
            <span className="font-display text-gold-grad text-2xl font-semibold">
                {letters}
            </span>
        </span>
        <span className="font-mono-lux text-[10px] tracking-[0.3em] text-[#E2E2E2]">
            {label}
        </span>
    </div>
);

export default function Authenticite() {
    return (
        <section
            id="authenticite"
            data-testid="section-authenticite"
            className="relative overflow-hidden border-t border-[#D4AF37]/15 py-24 sm:py-32"
        >
            <div className="glow-pulse pointer-events-none absolute left-1/2 top-1/2 h-[55vh] w-[70vw] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[radial-gradient(ellipse_at_center,rgba(212,175,55,0.08),transparent_65%)]" />
            <span className="pointer-events-none absolute left-8 top-8 h-9 w-9 border-l border-t border-[#D4AF37]/40 sm:left-16 sm:top-16" />
            <span className="pointer-events-none absolute bottom-8 right-8 h-9 w-9 border-b border-r border-[#D4AF37]/40 sm:bottom-16 sm:right-16" />

            <div className="relative z-10 mx-auto max-w-3xl px-5 text-center sm:px-10">
                <Reveal>
                    <p className="font-mono-lux mb-8 flex items-center justify-center gap-4 text-[11px] tracking-[0.4em] text-[#D4AF37]">
                        <span className="inline-block h-px w-10 bg-[#D4AF37]/60" />
                        AUTHENTICITÉ
                        <span className="inline-block h-px w-10 bg-[#D4AF37]/60" />
                    </p>
                </Reveal>
                <h2
                    data-testid="authenticite-title"
                    className="font-display text-3xl font-medium leading-tight tracking-tight text-white sm:text-4xl lg:text-5xl"
                >
                    <MaskedLine delay={0.1}>LE RÉEL, AVEC UNE</MaskedLine>
                    <MaskedLine delay={0.22}>
                        <span className="text-gold-grad italic">
                            TOUCHE DE MAGIE.
                        </span>
                    </MaskedLine>
                </h2>

                <Reveal delay={0.3}>
                    <div
                        data-testid="authenticite-text"
                        className="mx-auto mt-9 max-w-2xl space-y-5 text-base font-light leading-relaxed text-[#E2E2E2]/85 sm:text-lg"
                    >
                        <p>
                            Toutes mes photographies sont de vraies prises de
                            vue.
                        </p>
                        <p>
                            Je ne génère pas mes images avec l'intelligence
                            artificielle. Chaque photo est captée avec mon
                            appareil, dans le vrai monde, avec ses lumières,
                            ses émotions et ses moments uniques.
                        </p>
                        <p>
                            J'utilise ensuite Lightroom et Photoshop pour
                            travailler la lumière, les couleurs, les contrastes
                            et certains détails afin de donner à mes images
                            leur touche finale, tout en conservant leur
                            authenticité.
                        </p>
                        <p className="font-display text-xl italic text-[#D4AF37] sm:text-2xl">
                            La photographie reste réelle. La retouche apporte
                            simplement la petite touche magique.
                        </p>
                        <p>
                            Je peux également créer des créations artistiques
                            avec Photoshop lorsque le projet s'y prête,
                            toujours à partir de mes propres photographies.
                        </p>
                    </div>
                </Reveal>

                <Reveal delay={0.45}>
                    <div className="mt-12 flex items-center justify-center gap-8 sm:gap-14">
                        <AdobeTile
                            letters="Lr"
                            label="ADOBE LIGHTROOM"
                            testId="icon-lightroom"
                        />
                        <AdobeTile
                            letters="Ps"
                            label="ADOBE PHOTOSHOP"
                            testId="icon-photoshop"
                        />
                    </div>
                </Reveal>
            </div>
        </section>
    );
}
